import { z } from 'zod';

import { BASE_SCHEMAS, SCHEMAS } from './base';
import { outletInfoSchema } from './outlet';

export const businessInfoSchema = z.object({
  name: SCHEMAS.businessName,
  legalName: SCHEMAS.businessLegalName,
  type: SCHEMAS.businessType,
  scale: SCHEMAS.businessScale,
});

export const businessSettingsSchema = z.object({
  name: SCHEMAS.businessName,
  legalName: SCHEMAS.businessLegalName,
  description: z.string().max(1000).optional(),
  phone: BASE_SCHEMAS.optionalPhoneNumber('Phone'),
  email: SCHEMAS.businessEmail,
  gstinNumber: SCHEMAS.businessGstinNumber,
  type: SCHEMAS.businessType.optional(),
});

export const createBusinessSchema = z.object({
  business: businessInfoSchema,
  outlet: outletInfoSchema,
});

export type BusinessInfoData = z.infer<typeof businessInfoSchema>;
export type BusinessSettingsData = z.infer<typeof businessSettingsSchema>;
export type CreateBusinessData = z.infer<typeof createBusinessSchema>;
